// @unocss-include

import { Viewer2DHandle } from './Viewer2DHandle';

export class Viewer2DHandleBuilder {
  build() {
    return new Viewer2DHandle({
      canvasDom: this._createCanvasDom(),
    });
  }

  private _createCanvasDom() {
    const canvasDom = document.createElement('canvas');
    canvasDom.style.position = 'absolute';
    canvasDom.style.height = '100%';
    canvasDom.style.width = '100%';
    canvasDom.classList.add('bg-neutral-800');
    return canvasDom;
  }
}
